import { 
  Activity, 
  Binoculars,
  Bone,
  Briefcase,
  Building2, 
  Calendar, 
  Car, 
  ClipboardList, 
  Database, 
  Dog,
  FileText, 
  Fish, 
  Flower,
  GlobeLock,
  GraduationCap,
  Heart,
  Landmark,
  LayoutDashboard, 
  Map as MapIcon,
  Monitor,
  Network,
  Package,
  PawPrint,
  Search,
  Settings, 
  Shield, 
  Signature,
  Snail,
  Target,
  Trees,
  UserCheck,
  Users,
  UserCircle,
  ShieldCheck,
  LogOut,
  Info,
  Download,
  Upload,
  Cloud
} from 'lucide-react';

import { CiMicrophoneOn } from "react-icons/ci";
import { FaCat , FaDumpster, FaHamburger  } from "react-icons/fa";
import { FaMosquito   } from "react-icons/fa6";
import { GiCow , GiDeer, GiCrosscutSaw , GiGunStock , GiMushroom, GiRoundTable, GiWhistle } from 'react-icons/gi';
import { IoCalendarNumberOutline } from "react-icons/io5";
import { MenuItem } from './types';
import { PiPants , PiPark } from "react-icons/pi";

export const DEFAULT_MENU: MenuItem[] = [];

export const ICON_MAP: Record<string, any> = {
  LayoutDashboard,
  Users,
  Car,
  FileText,
  Building2,
  Fish,
  Shield,
  Calendar,
  ClipboardList,
  Settings,
  Database,
  Activity,
  MapIcon,
  GraduationCap,
  Monitor,
  Package,
  Network,
  PawPrint,
  Bone,
  Signature,
  GlobeLock,
  Binoculars,
  Target,
  Snail,
  Flower,
  Trees,
  Dog,
  Search,
  GiMushroom,
  GiGunStock,
  GiDeer,
  GiCow,
  GiWhistle,
  PiPark,
  PiPants,
  FaCat,
  FaDumpster,
  FaHamburger,
  FaMosquito,
  GiCrosscutSaw,
  CiMicrophoneOn,
  IoCalendarNumberOutline,
  GiRoundTable,
  Briefcase,
  Heart,
  Landmark,
  UserCheck,
  UserCircle,
  ShieldCheck,
  LogOut,
  Info,
  Download,
  Upload,
  Cloud
};
